module.exports = __webpack_public_path__ + "static/media/1.87eafb7b.png";